import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'
import { ReviewAnalysisDateRange } from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

export const useGetReviewAnalysisSpikeBreakdownQuery = (
  campaignId: string,
  date?: string,
  range?: ReviewAnalysisDateRange
) =>
  useQuery({
    enabled: !!campaignId,
    queryFn: () =>
      ReviewAnalysisApiService.getSpikeBreakdown(campaignId, date, range),
    queryKey: [
      QueryKey.GET_REVIEW_ANALYSIS_SPIKE_BREAKDOWN,
      campaignId,
      date ?? '',
      range?.from ?? '',
      range?.to ?? '',
    ],
  })
